import { RainbowKitProvider } from '@rainbow-me/rainbowkit'
import React, { useMemo } from 'react'

import { useIsDarkMode } from '@/state/user/hooks'

import { buildRainbowKitTheme } from './rainbowKitTheme'

export function RainbowKitAppProvider({ children }: { children: React.ReactNode }) {
  const darkMode = useIsDarkMode()
  const theme = useMemo(() => buildRainbowKitTheme(darkMode), [darkMode])

  return (
    <RainbowKitProvider
      theme={theme}
      appInfo={{
        appName: "Don't Panic DEX",
      }}
    >
      {children}
    </RainbowKitProvider>
  )
}
